import { IChangeUserStatusPayload, IBulkStatusPayload, IBulkStatusResponse, IEocnAuditTrailResponse, IEocnFlaggedUsersResponse, ISanctionsMatchResponse, IUpdateStatusResponse } from '@lib/interfaces/eocn.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EOCNService {
    private readonly environment_url: string;

    constructor(private readonly http: HttpClient) {
        this.environment_url = environment.eocn_url;
    }

    public getFlaggedUsers(queryParams: URLSearchParams): Observable<IEocnFlaggedUsersResponse> {
        return this.http.get<IEocnFlaggedUsersResponse>(`${this.environment_url}v1/users/get-flagged-users?${queryParams}`);
    }

    public getFlaggedUsersDetails(flagId: number): Observable<ISanctionsMatchResponse> {
        return this.http.get<ISanctionsMatchResponse>(`${this.environment_url}v1/users/flagged-user-details/${flagId}`);
    }

    public getFlaggedUsersAuditTrail(flagId: number): Observable<IEocnAuditTrailResponse> {
        return this.http.get<IEocnAuditTrailResponse>(`${this.environment_url}v1/flagged-users/${flagId}/audit-trail`);
    }

    public getExportMatchReport(queryParams: URLSearchParams): Observable<Blob> {
        return this.http.get(`${this.environment_url}v1/users/export-match-report?${queryParams}`, {
            responseType: 'blob',
        });
    }

    public updateUserStatus(payload: IChangeUserStatusPayload, flagId: number): Observable<IUpdateStatusResponse> {
        return this.http.post<IUpdateStatusResponse>(`${this.environment_url}v1/flagged-users/${flagId}/status`, payload);
    }

    public bulkUpdateStatus(payload: IBulkStatusPayload): Observable<IBulkStatusResponse> {
        return this.http.post<IBulkStatusResponse>(`${this.environment_url}v1/flagged-users/bulk-status`, payload);
    }
}
